import React from 'react';
import {makeStyles, Container, Grid, Paper, Dialog, AppBar, Toolbar, Slide, IconButton} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import LeaveForm from '../../LeaveApplication/component/Form'
import Balance from '../../LeaveApplication/component/Balance'
import RecentLeave from '../../LeaveApplication/component/RecentLeave'
import RecentLeaveCollection from '../../Function/RecentLeaveCollection'
import customAxios from "../../API/customAxios";
import {useIntl} from 'react-intl';
import MiniTable from "../../UIComponent/MiniTable";
import CompLeaveCollection from "../../Function/CompLeaveCollection";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
    },
    subPaper: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Form({handleClose, open, startDate, endDate, startTime, endTime}) {
    const mode = window.global.formMode;
    const classes = useStyles();
    const intl = useIntl();
    const [userData, setUserData] = React.useState({
        employee_name: null,
        staff_duty: null,
        user_role: null,
        annual_allowances: null,
        annual_total: null
    });
    const [rows, setRows] = React.useState([]);
    const [compLeaveRows, setCompLeaveRows] = React.useState([]);

    React.useEffect(() => {
        customAxios.get('/get_user_record')
            .then(res => {
                setUserData(res.data);
                setRows(RecentLeaveCollection(res.data['recent_leave'], intl));
                setCompLeaveRows(CompLeaveCollection(res.data['comp_leave_balance'], intl));
            })
    }, []);

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        backgroundColor: '#f0f2f5',
                        boxShadow: 'none',
                    },
                }}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={7}>
                        <Paper className={classes.mainPaper}>
                            <LeaveForm
                                mode={mode}
                                employeeId={userData.id}
                                employeeName={userData.employee_name}
                                staffDuty={userData.staff_duty}
                                annualAllowances={userData.annual_allowances}
                                annualTotal={userData.annual_total}
                                editStartTime={startTime}
                                editStartDate={startDate}
                                editEndTime={endTime}
                                editUntilDate={endDate}
                                compLeaveRows={compLeaveRows}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12} lg={5}>
                        <Paper className={classes.mainPaper}>
                            <Balance mode={mode} annualAllowances={userData.annual_allowances}/>
                        </Paper>
                        {userData.staff_duty === 'OFFICE HOURS' ? (
                            <Paper className={classes.subPaper}>
                                <MiniTable rows={compLeaveRows} />
                            </Paper>
                        ) : ''}
                        <Paper className={classes.subPaper}>
                            <RecentLeave rows={rows}/>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Dialog>
    )
}
